// extracted by mini-css-extract-plugin
module.exports = {"heading_wrapper":"Heading_heading_wrapper__ktKzO","heading":"Heading_heading__njkQq","overlay":"Heading_overlay__2lpsP"};